import SkeletonLoader from './SkeletonLoader.vue';

export default SkeletonLoader;
